import Handler from "./Handler";

// Tickets (Phase 7, staff backend /staff/tickets). Every call returns { ok, data, message }.
const BASE = "/staff/tickets";

const wrap = (response) => {
    if (response?.success) return { ok: true, data: response?.data?.data || {}, message: response?.data?.message || "" };
    return { ok: false, data: null, code: response?.data?.code, message: response?.data?.message || "Could not do that. Try again." };
};
const call = async (config) => wrap(await Handler({ ...config, silent: true }));

// With files: multipart; without: normal (encrypted) JSON.
const send = (url, fields, files = []) => {
    if (!files.length) return call({ method: "post", url, data: fields });
    const form = new FormData();
    Object.entries(fields).forEach(([key, value]) => { if (value !== undefined && value !== null) form.append(key, value); });
    files.forEach((file) => form.append("files", file));
    return call({ method: "post", url, data: form, formdata: true });
};

export const ticketApi = {
    counts: () => call({ method: "get", url: `${BASE}/counts` }),
    queue: (queue, params) => call({ method: "get", url: `${BASE}/queue/${queue}`, params }),
    options: () => call({ method: "get", url: `${BASE}/options` }),
    handlers: (search) => call({ method: "get", url: `${BASE}/handlers`, params: search ? { search } : {} }),
    raise: (fields, files) => send(BASE, fields, files),
    detail: (ticketId) => call({ method: "get", url: `${BASE}/${ticketId}` }),
    take: (ticketId) => call({ method: "post", url: `${BASE}/${ticketId}/take`, data: {} }),
    message: (ticketId, { body, internal, status }, files) => send(`${BASE}/${ticketId}/messages`, { body, internal: internal ? "true" : "false", ...(status ? { status } : {}) }, files),
    status: (ticketId, status, note) => call({ method: "post", url: `${BASE}/${ticketId}/status`, data: { status, ...(note ? { note } : {}) } }),
    resolve: (ticketId, message) => call({ method: "post", url: `${BASE}/${ticketId}/resolve`, data: { message } }),
    priority: (ticketId, priority) => call({ method: "post", url: `${BASE}/${ticketId}/priority`, data: { priority } }),
    reassign: (ticketId, staffId, note) => call({ method: "post", url: `${BASE}/${ticketId}/reassign`, data: { staffId, note } }),
    returnToPool: (ticketId, note) => call({ method: "post", url: `${BASE}/${ticketId}/return`, data: { note } }),
    appeal: (ticketId, reason) => call({ method: "post", url: `${BASE}/${ticketId}/appeal`, data: { reason } }),
    confirm: (ticketId, solved, note) => call({ method: "post", url: `${BASE}/${ticketId}/confirm`, data: { solved, ...(note ? { note } : {}) } }),
    reopen: (ticketId, reason) => call({ method: "post", url: `${BASE}/${ticketId}/reopen`, data: { reason } }),
};

export default ticketApi;
